import React, { Component } from 'react';
import PropTypes from 'prop-types';

// React error boundaries still require the class lifecycle API. All rider-facing
// feature components remain functional components with hooks.
class RouteErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, details) {
    console.error('Route view failed:', error, details);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="page-shell">
          <div className="inline-alert inline-alert--error" role="alert">
            <strong>This view could not open.</strong> The rest of Magic Bus is still available from the navigation.
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

RouteErrorBoundary.propTypes = {
  children: PropTypes.node.isRequired,
};

export default RouteErrorBoundary;
